import {createReducer} from "@reduxjs/toolkit";
import {createAction} from 'redux-actions';

export const setActiveTab = createAction("SET_ACTIVE_TAB");
export const addQuestionUpvote = createAction("ADD_QUESTION_UPVOTE");
export const removeQuestionUpvote = createAction("REMOVE_QUESTION_UPVOTE");

const reducer = createReducer({}, {
  [setActiveTab]: (state, action) => {
    state.activeTab = action.payload
  },
  [addQuestionUpvote]: (state, action) => {
    state.questionUpvotes = state.questionUpvotes.filter(questionUpvote => questionUpvote.event_question_id != action.payload.event_question_id)
    state.questionUpvotes.push(action.payload)
  },
  [removeQuestionUpvote]: (state, action) => {
    state.questionUpvotes = state.questionUpvotes.filter(questionUpvote => questionUpvote.event_question_id != action.payload.event_question_id)
  },

  ["CABLE_VIDEO_ROOM_CHAT_MESSAGE_CREATED"]: (state, action) => {
    state.videoRoomChat.messages = state.videoRoomChat.messages.filter(message => message.id != action.payload.id)
    state.videoRoomChat.messages.push(action.payload)
  },
  ["CABLE_VIDEO_ROOM_CHAT_MESSAGE_UPDATED"]: (state, action) => {
    state.videoRoomChat.messages = state.videoRoomChat.messages.filter(message => message.id != action.payload.id)
    state.videoRoomChat.messages.push(action.payload)
  },
  ["CABLE_VIDEO_ROOM_CHAT_MESSAGE_DESTROYED"]: (state, action) => {
    state.videoRoomChat.messages = state.videoRoomChat.messages.filter(message => message.id != action.payload.id)
  },
  ["CABLE_VIDEO_ROOM_CHAT_MESSAGES_BULK_CREATED"]: (state, action) => {
    action.payload.map(new_message => {
      state.videoRoomChat.messages = state.videoRoomChat.messages.filter(message => message.id != new_message.id)
      state.videoRoomChat.messages.push(new_message)
    })
  },
})
export default reducer